export default __webpack_public_path__ + "static/media/Leutrim-Syla.d14df0ce.jpg";